module.exports = __webpack_public_path__ + "static/media/wn_4.63c0d674.jpg";